import React from 'react';
import { motion } from 'framer-motion';
import { Plus, CheckCircle2, AlertCircle, HelpCircle } from 'lucide-react';
const members = [{
  name: 'Mark Thompson',
  role: 'Guitar, Vocals',
  acts: 'The Wildwoods',
  sync: 'synced',
  conflicts: 'None',
  rate: '$300/show'
}, {
  name: 'Sarah Chen',
  role: 'Bass',
  acts: 'The Wildwoods',
  sync: 'synced',
  conflicts: 'Jun 14 conflict',
  rate: '$250/show',
  hasConflict: true
}, {
  name: 'Tom Rivera',
  role: 'Drums',
  acts: 'The Wildwoods, Side Project',
  sync: 'synced',
  conflicts: 'Jun 14, Jun 22 conflicts',
  rate: '$275/show',
  hasConflict: true
}, {
  name: 'Lisa Park',
  role: 'Keys',
  acts: 'The Wildwoods',
  sync: 'not_synced',
  conflicts: 'Unknown',
  rate: '$250/show'
}, {
  name: 'Jake Morris',
  role: 'Substitute Guitar',
  acts: 'The Wildwoods',
  sync: 'manual',
  conflicts: 'Available Jun 14',
  rate: '$200/show',
  isSub: true
}];
export function LineupPage() {
  return <motion.div initial={{
    opacity: 0,
    y: 20
  }} animate={{
    opacity: 1,
    y: 0
  }} className="max-w-7xl mx-auto" data-id="element-3728">
      {/* Header */}
      <div className="flex justify-between items-center mb-6" data-id="element-3729">
        <h2 className="text-2xl font-bold" data-id="element-3730">Lineup & Personnel</h2>
        <button className="px-4 py-2 bg-primary text-background rounded-lg hover:bg-primaryHover transition-colors font-medium flex items-center gap-2 text-sm shadow-[0_0_10px_rgba(245,158,11,0.2)]" data-id="element-3731">
          <Plus className="w-4 h-4" data-id="element-3732" />
          Add Member
        </button>
      </div>

      {/* Summary Bar */}
      <div className="bg-surface border border-border rounded-xl p-4 mb-6 flex items-center gap-6" data-id="element-3733">
        <div className="flex items-center gap-2" data-id="element-3734">
          <div className="w-8 h-8 rounded-full bg-primary/10 flex items-center justify-center text-primary font-bold" data-id="element-3735">
            4
          </div>
          <span className="text-sm font-medium" data-id="element-3736">Required Members</span>
        </div>
        <div className="w-px h-8 bg-border" data-id="element-3737"></div>
        <div className="flex items-center gap-2" data-id="element-3738">
          <div className="w-8 h-8 rounded-full bg-surfaceHover border border-border flex items-center justify-center text-textMuted font-bold" data-id="element-3739">
            1
          </div>
          <span className="text-sm font-medium text-textMuted" data-id="element-3740">Substitute</span>
        </div>
        <div className="w-px h-8 bg-border" data-id="element-3741"></div>
        <div className="flex items-center gap-2" data-id="element-3742">
          <div className="w-8 h-8 rounded-full bg-red-500/10 flex items-center justify-center text-red-500 font-bold" data-id="element-3743">
            2
          </div>
          <span className="text-sm font-medium text-red-500" data-id="element-3744">
            Conflicts this month
          </span>
        </div>
      </div>

      {/* Table */}
      <div className="bg-surface border border-border rounded-xl overflow-hidden" data-id="element-3745">
        <div className="overflow-x-auto" data-id="element-3746">
          <table className="w-full text-sm text-left" data-id="element-3747">
            <thead className="bg-surface border-b border-border text-textMuted" data-id="element-3748">
              <tr data-id="element-3749">
                <th className="px-6 py-4 font-medium" data-id="element-3750">Member Name</th>
                <th className="px-6 py-4 font-medium" data-id="element-3751">Role / Instrument</th>
                <th className="px-6 py-4 font-medium" data-id="element-3752">Acts Linked</th>
                <th className="px-6 py-4 font-medium" data-id="element-3753">Availability Status</th>
                <th className="px-6 py-4 font-medium" data-id="element-3754">Upcoming Conflicts</th>
                <th className="px-6 py-4 font-medium text-right" data-id="element-3755">
                  Default Rate
                </th>
              </tr>
            </thead>
            <tbody className="divide-y divide-border bg-background" data-id="element-3756">
              {members.map((member, i) => <tr key={i} className={`hover:bg-surface/50 transition-colors group ${member.hasConflict ? 'bg-red-500/[0.02]' : ''}`} data-id="element-3757">
                  <td className="px-6 py-4 font-medium flex items-center gap-3" data-id="element-3758">
                    <div className="w-8 h-8 rounded-full bg-surface border border-border flex items-center justify-center text-xs text-textMuted" data-id="element-3759">
                      {member.name.charAt(0)}
                    </div>
                    <div data-id="element-3760">
                      <div className="group-hover:text-primary transition-colors" data-id="element-3761">
                        {member.name}
                      </div>
                      {member.isSub && <div className="text-[10px] text-textMuted uppercase tracking-wider mt-0.5" data-id="element-3762">
                          Substitute
                        </div>}
                    </div>
                  </td>
                  <td className="px-6 py-4 text-textMuted" data-id="element-3763">{member.role}</td>
                  <td className="px-6 py-4 text-textMuted" data-id="element-3764">{member.acts}</td>
                  <td className="px-6 py-4" data-id="element-3765">
                    <div className="flex items-center gap-1.5" data-id="element-3766">
                      {member.sync === 'synced' ? <>
                          <CheckCircle2 className="w-4 h-4 text-green-500" data-id="element-3767" />{' '}
                          <span className="text-textMuted" data-id="element-3768">Synced</span>
                        </> : member.sync === 'not_synced' ? <>
                          <HelpCircle className="w-4 h-4 text-amber-500" data-id="element-3769" />{' '}
                          <span className="text-textMuted" data-id="element-3770">Not synced</span>
                        </> : <>
                          <span className="w-4 h-4 rounded-full border border-textMuted flex items-center justify-center text-[10px]" data-id="element-3771">
                            M
                          </span>{' '}
                          <span className="text-textMuted" data-id="element-3772">Manual</span>
                        </>}
                    </div>
                  </td>
                  <td className="px-6 py-4" data-id="element-3773">
                    {member.hasConflict ? <span className="flex items-center gap-1.5 text-red-500 font-medium" data-id="element-3774">
                        <AlertCircle className="w-4 h-4" data-id="element-3775" /> {member.conflicts}
                      </span> : <span className="text-textMuted" data-id="element-3776">{member.conflicts}</span>}
                  </td>
                  <td className="px-6 py-4 text-right text-textMuted" data-id="element-3777">
                    {member.rate}
                  </td>
                </tr>)}
            </tbody>
          </table>
        </div>
      </div>
    </motion.div>;
}